import { Button, Form } from 'antd';
import FormBuilder from 'antd-form-builder';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React, { memo, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useDeepCompareEffect from 'use-deep-compare-effect';

import FloatContainer, { TYPE_CONTAINER } from '@/components/FloatContainer';
import { useDialogsContext } from '@/contexts/DialogsContext';
import { useResponsive } from '@/contexts/ResponsiveContext';
import MarriedInformation from '@/modules/authentication/pages/SignUp/components/MarriedInformation';
import { DIALOG_GENERAL_PARTNER_NAMESPACE } from '@/modules/proposalRequest/contants/proposalRequest';

const ProposalRequestPartnerGeneralDataModal = ({ onConfirm, dialogContext, title }) => {
  const { t } = useTranslation('proposalRequest');
  const { isOpen, closeDialog, payload } = useDialogsContext(dialogContext || DIALOG_GENERAL_PARTNER_NAMESPACE);
  const { isMobile } = useResponsive();
  const [form] = Form.useForm();
  const forceUpdate = FormBuilder.useForceUpdate();
  const initValues = Object.assign({}, payload?.partner || {});

  useEffect(() => {
    isOpen && form.resetFields();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const onCLose = useCallback(() => {
    closeDialog();
    form.resetFields();
  }, [closeDialog, form]);

  const handleSubmit = useCallback(async (values) => {
    await onConfirm(values?.civilStatusInfo, payload?.isEdit, payload?.recordIndex, payload?.isRepresentative);
    onCLose();
  }, [onConfirm, payload?.isEdit, payload?.recordIndex, payload?.isRepresentative, onCLose]);

  useDeepCompareEffect(() => {
    if (!isEmpty(initValues)) {
      form.setFieldsValue(initValues);
    }
  }, [initValues]);

  return (
    <FloatContainer
      type={isMobile ? TYPE_CONTAINER.DRAWER : TYPE_CONTAINER.MODAL}
      visible={isOpen}
      title={title}
      closable={false}
      bodyStyle={{ padding: '1.5rem 1.5rem 0 1.5rem' }}
      onClose={onCLose}
      width={700}
      footer={[
        <Button className="mx-2" key="back" onClick={onCLose}>
          {t('cancel')}
        </Button>,
        <Button className="mx-2" key="submit" type="primary" onClick={() => form.submit()}>
          {t('confirm')}
        </Button>,
      ]}>
      <Form
        scrollToFirstError
        form={form}
        onFinish={handleSubmit}
        layout="vertical"
        onValuesChange={forceUpdate}
        initialValues={initValues}>
        <MarriedInformation value={initValues} noTitle noBorder isEdit={payload?.isEdit} form={form} dpaRequired/>
      </Form>
    </FloatContainer>);
};

ProposalRequestPartnerGeneralDataModal.propTypes = {
  dialogContext: PropTypes.string,
  title: PropTypes.string,
  isStatePartner: PropTypes.bool,
  onConfirm: PropTypes.func
};

ProposalRequestPartnerGeneralDataModal.defaultProps = {};

export default memo(ProposalRequestPartnerGeneralDataModal);
